import { useCallback, useRef } from 'react';
import { prepareBCOSSUrl } from '@utils/utils';
import { fileApi } from '@services/Conference';
import RichEditor from '@components/common/RichEditor';

/** 医邀请邀请用户、会议嘉宾行程等：富文本与 Ant Design Form 联动 */
const TinyMCEEditor = ({ form, fieldValue, initialValue, id, placeholder, value, onChange }) => {
    const prevIdRef = useRef(id);
    const mountInitialHtmlRef = useRef(undefined);
    if (prevIdRef.current !== id || mountInitialHtmlRef.current === undefined) {
        prevIdRef.current = id;
        mountInitialHtmlRef.current = value ?? initialValue ?? '';
    }
    const imageUploadHandler = useCallback(async blobInfo => {
        const formData = new FormData();
        formData.append('file', blobInfo.blob());
        formData.append('path', '');

        const res = await fileApi(formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        if (res && res.data) {
            return prepareBCOSSUrl(res.data);
        }
    }, []);

    const handleChange = useCallback(
        html => {
            const fieldVal = html === '' ? undefined : html;
            onChange?.(fieldVal);
            if (form && fieldValue) {
                form.setFieldValue(fieldValue, fieldVal);
                if (fieldVal) {
                    form.setFields([{ name: fieldValue, errors: null }]);
                }
            }
        },
        [form, fieldValue, onChange],
    );

    if (!id) {
        return null;
    }

    const formControlled = typeof onChange === 'function';

    return <RichEditor id={id} mode="full" height={300} placeholder={placeholder} value={formControlled ? (value ?? '') : undefined} initialValue={formControlled ? undefined : (mountInitialHtmlRef.current ?? '')} onChange={handleChange} imageUploadHandler={imageUploadHandler} />;
};

export default TinyMCEEditor;
